import {
	HYPHEN_MINUS,
	LONG_DASH,
	NOT_APPLICABLE,
} from '@dealstack/frontend/shared/other/react/specialSigns';

export const isDisplayValueValid = (value: unknown): boolean => {
	if (value === null || value === undefined) {
		return false;
	}

	if (typeof value === 'string') {
		const trimmed = value.trim();
		return (
			trimmed !== '' &&
			trimmed !== HYPHEN_MINUS &&
			trimmed !== LONG_DASH &&
			trimmed !== NOT_APPLICABLE
		);
	}

	return true;
};
